module.exports = __webpack_public_path__ + "img/george-thompson.366deadd.png";